import {
  Navigate,
  Outlet,
  createRootRoute,
  createRoute,
  createRouter,
} from "@tanstack/react-router";
import AppLayout from "./layouts/AppLayout";
import NavigationLayout from "./layouts/NavigationLayout";
import CreateAiPage from "./pages/CreateAiPage";
import MyGenerationsPage from "./pages/MyGenerationsPage";

function RootComponent() {
  return (
    <AppLayout>
      <Outlet />
    </AppLayout>
  );
}

const rootRoute = createRootRoute({
  component: RootComponent,
  notFoundComponent: () => <Navigate to="/" replace />,
});

const navigationRoutes = createRoute({
  getParentRoute: () => rootRoute,
  id: "navigation",
  component: NavigationLayout,
});

const routeTree = rootRoute.addChildren([
  navigationRoutes.addChildren([
    createRoute({
      getParentRoute: () => navigationRoutes,
      path: "/",
      component: CreateAiPage,
    }),
    createRoute({
      getParentRoute: () => navigationRoutes,
      path: "/my-generations",
      component: MyGenerationsPage,
    }),
  ]),
]);

export function createAppRouter() {
  return createRouter({
    routeTree,
    scrollRestoration: true,
  });
}

declare module "@tanstack/react-router" {
  interface Register {
    router: ReturnType<typeof createAppRouter>;
  }
}
